import * as yup from 'yup';

import { emailValidationSchema } from 'src/constants/validation';

import { InviteFormFields } from '../types';

export const inviteFormValidationSchema = yup.object({
  [InviteFormFields.email]: emailValidationSchema.required('Email is required'),
  [InviteFormFields.firstName]: yup.string().required('First Name is required'),
  [InviteFormFields.lastName]: yup.string().required('Last Name is required'),
  [InviteFormFields.displayName]: yup.string().required('Display Name is required'),
});
